.monaco-editor .mwh{color:var(--vscode-editorWhitespace-foreground)!important;position:absolute}